import React from "react";
import BuyerCardFeatured from "./BuyerCardFeatured";
import BuyerCardCompact from "./BuyerCardCompact";
import RichText from "./RichText";
import LegalStrip from "./LegalStrip";

const renderTileValue = (display) => {
  if (typeof display !== "string") return display;
  return display.split(/(\$|K|M|%)/g).map((token, idx) => {
    if (token === "$" || token === "K" || token === "M" || token === "%") {
      return <span key={idx} className="abr-unit">{token}</span>;
    }
    return <React.Fragment key={idx}>{token}</React.Fragment>;
  });
};

const MatchPool = ({ pool, property, agent, matches }) => {
  if (!pool) return null;
  return (
    <section id="pool" className="abr-section" aria-labelledby="abr-pool-title">
      <div className="abr-eyebrow">Your Match Pool</div>
      <h2 className="abr-h1" id="abr-pool-title">
        {pool.title}
      </h2>
      <p className="abr-lede">
        Your top {matches.featuredCount} of {matches.totalMatches} matches, shown anonymized. Each card is a single
        buyer-agent-submitted Want-Listing in <span className="abr-accent">{property.zip}</span> with real criteria,
        motivation, and intent signals - not aggregated patterns.
      </p>

      {pool.featured && pool.featured.length ? (
        <div className="abr-featured-cards">
          {pool.featured.map((buyer) => (
            <BuyerCardFeatured key={buyer.id} buyer={buyer} />
          ))}
        </div>
      ) : null}

      {pool.additional && pool.additional.length ? (
        <div className="abr-match-rows-wrap">
          <div className="abr-match-rows-caption">{pool.additionalCaption}</div>
          <div className="abr-match-rows">
            {pool.additional.map((row) => (
              <BuyerCardCompact row={row} key={row.id} />
            ))}
          </div>
        </div>
      ) : null}

      {pool.tiles && pool.tiles.length ? (
        <div style={{ marginTop: 36 }}>
          <div className="abr-card-title">Across all your matches</div>
          <p className="abr-card-sub">Aggregates across every matched buyer - not just the cards above.</p>
          <div className="abr-stat-tiles">
            {pool.tiles.map((tile, idx) => {
              const valueCls = `abr-tile-value${tile.accent ? " is-accent" : ""}${tile.wordy ? " is-wordy" : ""}`;
              return (
                <div key={idx} className="abr-card abr-tile">
                  <div className="abr-mini-eyebrow">{tile.eyebrow}</div>
                  <div className={valueCls}>{renderTileValue(tile.valueDisplay)}</div>
                  <div className="abr-tile-sub">{tile.sub}</div>
                </div>
              );
            })}
          </div>
        </div>
      ) : null}

      <div className="abr-bottom-line">
        <span className="abr-bottom-line-label">Bottom line</span>
        <RichText as="span" className="abr-bottom-line-text" text={pool.bottomLine} />
      </div>

      <LegalStrip agent={agent} />
    </section>
  );
};

export default MatchPool;
